import ElementoQuimico from "./interfaces/ElementoQuimico";

// Tipagem intermediária, para classificação dos períodos
export type Organizacao = {
    periodos: Array<Array<LinhaDados>>,
    lantanideos: Array<LinhaDados>,
    actinideos: Array<LinhaDados>
};

type LinhaDados = {
    existe: boolean,
    z: number,
    elemento: ElementoQuimico
}

export default class TabelaPeriodica {

    static getAll(): ElementoQuimico[] {
        return TabelaPeriodica.elementos;
    }

    static getTabela() {
        // Define a estrutura de resposta
        const res: Organizacao = {
            periodos: [[], [], [], [], [], [], []],
            lantanideos: [],
            actinideos: []
        };

        // Cria a estrutura dos períodos e das famílias extra
        const grid = [
            [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2],
            [3, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 6, 7, 8, 9, 10],
            [11, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13, 14, 15, 16, 17, 18],
            [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36],
            [37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54],
            [55, 56, 0, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86],
            [87, 88, 0, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118]
        ]
        const extra = [
            [57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71],
            [89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103]
        ];

        // Preenche a estrutura de resposta
        for(let i = 0; i < grid.length; i++) {
            for(let j = 0; j < grid[i].length; j++) {
                let indc = (grid[i][j] == 0) ? 0 : grid[i][j] - 1;
                res.periodos[i][j] = {
                    existe: (grid[i][j] == 0) ? false : true,
                    z: grid[i][j],
                    elemento: TabelaPeriodica.elementos[indc]
                };
            }
        }

        // Preenche as famílias extra
        for(let i = 0; i < extra.length; i++) {
            for(let j = 0; j < extra[i].length; j++) {
                let indc = (extra[i][j] == 0) ? 0 : extra[i][j] - 1;

                if(i == 0) {
                    res.lantanideos[j] = {
                        existe: (extra[i][j] == 0) ? false : true,
                        z: extra[i][j],
                        elemento: TabelaPeriodica.elementos[indc]
                    };
                }
                if(i == 1) {
                    res.actinideos[j] = {
                        existe: (extra[i][j] == 0) ? false : true,
                        z: extra[i][j],
                        elemento: TabelaPeriodica.elementos[indc]
                    };
                }
            }
        }

        return res;
    }

    static get(simbolo: string): ElementoQuimico | undefined {
        return TabelaPeriodica.elementos.find(el => el.simbolo == simbolo);
    }

    static elementos: ElementoQuimico[] = [
        { "simbolo": "H", "nome": "Hidrogênio", "massaMolar": 1.008 },
        { "simbolo": "He", "nome": "Hélio", "massaMolar": 4.0026 },
        { "simbolo": "Li", "nome": "Lítio", "massaMolar": 6.94 },
        { "simbolo": "Be", "nome": "Berílio", "massaMolar": 9.0122 },
        { "simbolo": "B", "nome": "Boro", "massaMolar": 10.81 },
        { "simbolo": "C", "nome": "Carbono", "massaMolar": 12.011 },
        { "simbolo": "N", "nome": "Nitrogênio", "massaMolar": 14.007 },
        { "simbolo": "O", "nome": "Oxigênio", "massaMolar": 15.999 },
        { "simbolo": "F", "nome": "Flúor", "massaMolar": 18.998 },
        { "simbolo": "Ne", "nome": "Neon", "massaMolar": 20.18 },
        { "simbolo": "Na", "nome": "Sódio", "massaMolar": 22.99 },
        { "simbolo": "Mg", "nome": "Magnésio", "massaMolar": 24.305 },
        { "simbolo": "Al", "nome": "Alumínio", "massaMolar": 26.982 },
        { "simbolo": "Si", "nome": "Silício", "massaMolar": 28.085 },
        { "simbolo": "P", "nome": "Fósforo", "massaMolar": 30.974 },
        { "simbolo": "S", "nome": "Enxofre", "massaMolar": 32.06 },
        { "simbolo": "Cl", "nome": "Cloro", "massaMolar": 35.45 },
        { "simbolo": "Ar", "nome": "Argônio", "massaMolar": 39.948 },
        { "simbolo": "K", "nome": "Potássio", "massaMolar": 39.098 },
        { "simbolo": "Ca", "nome": "Cálcio", "massaMolar": 40.078 },
        { "simbolo": "Sc", "nome": "Escândio", "massaMolar": 44.956 },
        { "simbolo": "Ti", "nome": "Titânio", "massaMolar": 47.867 },
        { "simbolo": "V", "nome": "Vanádio", "massaMolar": 50.942 },
        { "simbolo": "Cr", "nome": "Crômio", "massaMolar": 51.996 },
        { "simbolo": "Mn", "nome": "Manganês", "massaMolar": 54.938 },
        { "simbolo": "Fe", "nome": "Ferro", "massaMolar": 55.845 },
        { "simbolo": "Co", "nome": "Cobalto", "massaMolar": 58.933 },
        { "simbolo": "Ni", "nome": "Níquel", "massaMolar": 58.693 },
        { "simbolo": "Cu", "nome": "Cobre", "massaMolar": 63.546 },
        { "simbolo": "Zn", "nome": "Zinco", "massaMolar": 65.38 },
        { "simbolo": "Ga", "nome": "Gálio", "massaMolar": 69.723 },
        { "simbolo": "Ge", "nome": "Germânio", "massaMolar": 72.63 },
        { "simbolo": "As", "nome": "Arsênio", "massaMolar": 74.922 },
        { "simbolo": "Se", "nome": "Selênio", "massaMolar": 78.971 },
        { "simbolo": "Br", "nome": "Bromo", "massaMolar": 79.904 },
        { "simbolo": "Kr", "nome": "Criptônio", "massaMolar": 83.798 },
        { "simbolo": "Rb", "nome": "Rubídio", "massaMolar": 85.468 },
        { "simbolo": "Sr", "nome": "Estrôncio", "massaMolar": 87.62 },
        { "simbolo": "Y", "nome": "Itrio", "massaMolar": 88.906 },
        { "simbolo": "Zr", "nome": "Zircônio", "massaMolar": 91.224 },
        { "simbolo": "Nb", "nome": "Nióbio", "massaMolar": 92.906 },
        { "simbolo": "Mo", "nome": "Molibdênio", "massaMolar": 95.95 },
        { "simbolo": "Tc", "nome": "Tecnécio", "massaMolar": 98 },
        { "simbolo": "Ru", "nome": "Rutênio", "massaMolar": 101.07 },
        { "simbolo": "Rh", "nome": "Ródio", "massaMolar": 102.91 },
        { "simbolo": "Pd", "nome": "Paládio", "massaMolar": 106.42 },
        { "simbolo": "Ag", "nome": "Prata", "massaMolar": 107.87 },
        { "simbolo": "Cd", "nome": "Cádmio", "massaMolar": 112.41 },
        { "simbolo": "In", "nome": "Indio", "massaMolar": 114.82 },
        { "simbolo": "Sn", "nome": "Estanho", "massaMolar": 118.71 },
        { "simbolo": "Sb", "nome": "Antimônio", "massaMolar": 121.76 },
        { "simbolo": "Te", "nome": "Telúrio", "massaMolar": 127.6 },
        { "simbolo": "I", "nome": "Iodo", "massaMolar": 126.9 },
        { "simbolo": "Xe", "nome": "Xenônio", "massaMolar": 126.9 },
        { "simbolo": "Cs", "nome": "Césio", "massaMolar": 132.91 },
        { "simbolo": "Ba", "nome": "Bário", "massaMolar": 137.33 },
        { "simbolo": "La", "nome": "Lantânio", "massaMolar": 138.91 },
        { "simbolo": "Ce", "nome": "Cério", "massaMolar": 140.12 },
        { "simbolo": "Pr", "nome": "Preseodímio", "massaMolar": 140.91 },
        { "simbolo": "Nd", "nome": "Neodímio", "massaMolar": 144.24 },
        { "simbolo": "Pm", "nome": "Promécio", "massaMolar": 145 },
        { "simbolo": "Sm", "nome": "Samário", "massaMolar": 150.36 },
        { "simbolo": "Eu", "nome": "Európio", "massaMolar": 151.96 },
        { "simbolo": "Gd", "nome": "Gadolínio", "massaMolar": 157.25 },
        { "simbolo": "Tb", "nome": "Térbio", "massaMolar": 158.93 },
        { "simbolo": "Dy", "nome": "Disprósio", "massaMolar": 162.5 },
        { "simbolo": "Ho", "nome": "Hólmio", "massaMolar": 164.93 },
        { "simbolo": "Er", "nome": "Érbio", "massaMolar": 167.26 },
        { "simbolo": "Tm", "nome": "Túlio", "massaMolar": 168.93 },
        { "simbolo": "Yb", "nome": "Itérbio", "massaMolar": 173.05 },
        { "simbolo": "Lu", "nome": "Lutécio", "massaMolar": 174.97 },
        { "simbolo": "Hf", "nome": "Háfnio", "massaMolar": 178.49 },
        { "simbolo": "Ta", "nome": "Tântalo", "massaMolar": 180.95 },
        { "simbolo": "W", "nome": "Tungstênio", "massaMolar": 183.84 },
        { "simbolo": "Re", "nome": "Rênio", "massaMolar": 186.21 },
        { "simbolo": "Os", "nome": "Osmio", "massaMolar": 190.23 },
        { "simbolo": "Ir", "nome": "Irídio", "massaMolar": 192.22 },
        { "simbolo": "Pt", "nome": "Platina", "massaMolar": 195.08 },
        { "simbolo": "Au", "nome": "Ouro", "massaMolar": 196.97 },
        { "simbolo": "Hg", "nome": "Mercúrio", "massaMolar": 200.59 },
        { "simbolo": "Ta", "nome": "Tálio", "massaMolar": 204.38 },
        { "simbolo": "Pb", "nome": "Chumbo", "massaMolar": 207.2 },
        { "simbolo": "Bi", "nome": "Bismuto", "massaMolar": 208.98 },
        { "simbolo": "Po", "nome": "Polônio", "massaMolar": 209 },
        { "simbolo": "At", "nome": "Astato", "massaMolar": 210 },
        { "simbolo": "Rn", "nome": "Radônio", "massaMolar": 222 },
        { "simbolo": "Fr", "nome": "Frâncio", "massaMolar": 223 },
        { "simbolo": "Ra", "nome": "Rádio", "massaMolar": 226 },
        { "simbolo": "Ac", "nome": "Actínio", "massaMolar": 227 },
        { "simbolo": "Th", "nome": "Tório", "massaMolar": 232.04 },
        { "simbolo": "Pa", "nome": "Protactínio", "massaMolar": 231.04 },
        { "simbolo": "U", "nome": "Urânio", "massaMolar": 238.06 },
        { "simbolo": "Np", "nome": "Neptúnio", "massaMolar": 237 },
        { "simbolo": "Pu", "nome": "Plutônio", "massaMolar": 244 },
        { "simbolo": "Am", "nome": "Amerício", "massaMolar": 243 },
        { "simbolo": "Cm", "nome": "Cúrio", "massaMolar": 247 },
        { "simbolo": "Bk", "nome": "Berquélio", "massaMolar": 247 },
        { "simbolo": "Cf", "nome": "Califórnio", "massaMolar": 251 },
        { "simbolo": "Es", "nome": "Einstênio", "massaMolar": 252 },
        { "simbolo": "Fm", "nome": "Férmio", "massaMolar": 257 },
        { "simbolo": "Md", "nome": "Mendelévio", "massaMolar": 258 },
        { "simbolo": "No", "nome": "Nobélio", "massaMolar": 259 },
        { "simbolo": "Lr", "nome": "Laurêncio", "massaMolar": 266 },
        { "simbolo": "Rf", "nome": "Rutherfórdio", "massaMolar": 267 },
        { "simbolo": "Db", "nome": "Dúbnio", "massaMolar": 268 },
        { "simbolo": "Sg", "nome": "Seabórgio", "massaMolar": 269 },
        { "simbolo": "Bh", "nome": "Bóhrio", "massaMolar": 270 },
        { "simbolo": "Hs", "nome": "Hássio", "massaMolar": 277 },
        { "simbolo": "Mt", "nome": "Meitnério", "massaMolar": 278 },
        { "simbolo": "Ds", "nome": "Damstácio", "massaMolar": 281 },
        { "simbolo": "Rg", "nome": "Roentgênio", "massaMolar": 282 },
        { "simbolo": "Cn", "nome": "Copemício", "massaMolar": 285 },
        { "simbolo": "Nh", "nome": "Nihonium", "massaMolar": 286 },
        { "simbolo": "Fl", "nome": "Fleróvio", "massaMolar": 289 },
        { "simbolo": "Mc", "nome": "Moscovium", "massaMolar": 290 },
        { "simbolo": "Lv", "nome": "Livemório", "massaMolar": 293 },
        { "simbolo": "Ts", "nome": "Tennessine", "massaMolar": 294 },
        { "simbolo": "Og", "nome": "Oganesson", "massaMolar": 294 }
    ];

}